import { Component, Input, OnInit, ViewChild, ElementRef, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Inject } from '@angular/core';
import { MODAL_REF, ModalRef } from 'src/app/services/modal/modal-ref.token';

@Component({
    selector: 'app-hidden-participants-warning',
    templateUrl: './hidden-participants-warning.component.html',
    styleUrls: ['./hidden-participants-warning.component.scss'],
    standalone: false
})
export class HiddenParticipantsWarningComponent implements OnInit {
  @ViewChild('swiperRef') swiperRef: ElementRef;
  @Input() visibleParticipantNb: number;
  isEndOfSlides = false;

  constructor(
    @Inject(MODAL_REF) private modalRef: ModalRef
  ) { }

  ngOnInit() {
    if (this.swiperRef?.nativeElement?.swiper) {
      this.swiperRef.nativeElement.swiper.slideTo(0);
    }
  }

  public dismissModal() {
    this.modalRef.dismiss();
  }

  public onSlideChange() {
    if (this.swiperRef?.nativeElement?.swiper) {
      const activeIndex = this.swiperRef.nativeElement.swiper.activeIndex;
      this.isEndOfSlides = activeIndex === 1;
    }
  }

  public swipeNext() {
    if (this.swiperRef?.nativeElement?.swiper) {
      this.swiperRef.nativeElement.swiper.slideNext();
    }
  }

  public swipePrevious() {
    if (this.swiperRef?.nativeElement?.swiper) {
      this.swiperRef.nativeElement.swiper.slidePrev();
    }
  }
}
